<template>
    <div>
        <el-card class="search-form-card">
            <el-form ref="form" :inline="true" :model="form" class="search-form">
                <el-form-item label="故障简述:">
                    <el-input v-model="form.title" placeholder="请输入故障简述"></el-input>
                </el-form-item>
                <el-form-item label="级别:">
                    <el-select v-model="form.level" placeholder="请选择">
                        <el-option v-for="item in levelLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="SLA:">
                    <el-select v-model="form.sla" placeholder="请选择">
                        <el-option v-for="item in levelLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </el-card>
        <el-card>
            <div slot="header">
                <el-button type="primary">导出</el-button>
            </div>
            <el-table :data="tableData" v-loading="loading" >
                <el-table-column label="序号" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="form.pageSize===10"> {{form.pageNum>1 ? scope.$index+1+(form.pageNum-1)*10 : scope.$index+1}}</span>
                        <span v-if="form.pageSize===20"> {{form.pageNum>1 ? scope.$index+1+(form.pageNum-1)*20 : scope.$index+1}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="VIN" prop="vinCode" min-width="150"></el-table-column>
                <el-table-column label="车型" min-width="130" prop="noticeModel"></el-table-column>

            </el-table>

        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form:{
                    title:"",
                    level:"1",
                    sla:"1"
                },
                levelLists:[
                    {id:"1",name:"11"},
                    {id:"2",name:"22"},
                ],
                loading:true,
                tableData:[]
            }
        },
        created() {

        },
        methods: {}
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>